module.exports = __webpack_public_path__ + "img/plus-white.eeef5192.svg";